var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 64,
    fill: "#f7f7f8",
    fillOpacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    d: "M107.3 111a63.3 63.3 0 0 1-86 .5A72.1 72.1 0 0 1 52 96l1.7-6.9c-4.5-4.5-8.9-12-9.6-17.9-5.2-1.8-7.3-12.2-3.9-16.8-1.9-29 12.2-32 24-32.2 15.2-.2 27.3 6.2 24 32 4.4 3.9 2.5 15.2-2.9 15.4a37 37 0 0 1-9.6 19.6l1 6.2c8.8 2.7 20 7.8 30.5 15.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPhoto);
export default __webpack_public_path__ + "static/media/default-photo.63448c8c80b5cf98cc6403acd181e96a.svg";
export { ForwardRef as ReactComponent };